import { AttachmentRow } from "@ext/agent/components/panel/AttachmentRow";
import { DraftImageAttachment } from "@ext/agent/components/panel/DraftImageAttachment";
import { FileAttachmentTile } from "@ext/agent/components/panel/FileAttachmentTile";
import { isImageAttachment } from "@ext/agent/components/utils/attachment";
import type { StoredAttachment } from "@ext/agent/core/attachmentStore";

type Props = {
	attachments: StoredAttachment[];
	onRemove: (index: number) => void;
};

export const ChatInputAttachments = ({ attachments, onRemove }: Props) => (
	<AttachmentRow className="mb-2">
		{attachments.map((attachment, index) =>
			isImageAttachment(attachment) ? (
				<DraftImageAttachment
					attachment={attachment}
					key={attachment.storagePath}
					onRemove={() => onRemove(index)}
				/>
			) : (
				<FileAttachmentTile
					key={attachment.storagePath}
					mime={attachment.mime}
					name={attachment.originalFilename}
					onRemove={() => onRemove(index)}
				/>
			),
		)}
	</AttachmentRow>
);
